import AdaptiveTable from "@components/AdaptiveTable";
import { Panel } from "@components/global/new/Panel/Panel";
import { Button, Segmented } from "antd";
import { SegmentedLabeledOption, SegmentedOptions, SegmentedValue } from "antd/lib/segmented";
import styles from "./MinerRowMoreControl.module.scss"
import Loader from "@components/global/Loader/Loader";

export interface PanelTableRow {
  readonly values: (string | number)[];
}

interface PanelWithTableProps {
  caption: string;
  segments: SegmentedLabeledOption[];
  columns: string[];
  rows: PanelTableRow[];
  additional?: React.ReactNode;
  isLoading: boolean;
  onSegmentChanged: (value: SegmentedValue) => void;
}

function PanelWithTable({
  caption,
  segments,
  columns,
  rows,
  additional,
  isLoading = false,
  onSegmentChanged,
}: PanelWithTableProps): JSX.Element {
  return (
    <Panel theme="light" className={styles.panelWithTable}>
      <div className={styles.panelHeader}>
        <h4>{caption}</h4>
        <Segmented
          options={segments}
          onChange={onSegmentChanged}
        />
        {additional && (
          <div className={styles.panelHeader_additional}>
            {additional}
          </div>
        )}
      </div>
      <div style={{ position: "relative" }}>
        {isLoading && <Loader />}
        <AdaptiveTable>
          <AdaptiveTable.Head>
            <AdaptiveTable.Row>
              {columns.map((column, i) => (
                <AdaptiveTable.HeaderCell key={i}>
                  {column}
                </AdaptiveTable.HeaderCell>
              ))}
            </AdaptiveTable.Row>
          </AdaptiveTable.Head>
          <AdaptiveTable.Body>
            {rows.length === 0 && (
              <AdaptiveTable.Row colspan={columns.length} className={styles.grayRow}>
                нет записей
              </AdaptiveTable.Row>
            )}
            {rows.map((row, i) => {
              return (
                <AdaptiveTable.Row key={i}>
                  {row.values.map((value, j) => (
                    <AdaptiveTable.Cell label={columns[j]} key={j}>
                      {value}
                    </AdaptiveTable.Cell>
                  ))}
                </AdaptiveTable.Row>
              );
            })}
          </AdaptiveTable.Body>
        </AdaptiveTable>
      </div>
    </Panel>
  );
}

export default PanelWithTable;